import { Field, Int, ObjectType } from '@nestjs/graphql'
import defaultPreferences from './defaultPreferences.json'

@ObjectType()
export class UserPreferencesDto  {
  // Admin stuff (not to be make available in the UI)
  @Field(t => Int, { defaultValue: defaultPreferences.penNameLimit })
  public penNameLimit: number = defaultPreferences.penNameLimit

  // Author
  @Field({ defaultValue: defaultPreferences.reminderBookLinks })
  public reminderBookLinks: boolean = defaultPreferences.reminderBookLinks

  @Field({ defaultValue: defaultPreferences.dailyUpdatesOnFollowCount })
  public dailyUpdatesOnFollowCount: boolean = defaultPreferences.dailyUpdatesOnFollowCount

  @Field({ defaultValue: defaultPreferences.alertTimeToPublish })
  public alertTimeToPublish: boolean = defaultPreferences.alertTimeToPublish

  @Field({ defaultValue: defaultPreferences.alertNewArcParticipant })
  public alertNewArcParticipant: boolean = defaultPreferences.alertNewArcParticipant

  @Field({ defaultValue: defaultPreferences.alertNewReview })
  public alertNewReview: boolean = defaultPreferences.alertNewReview

  @Field({ defaultValue: defaultPreferences.alertArcCancellation })
  public alertArcCancellation: boolean = defaultPreferences.alertArcCancellation

  @Field({ defaultValue: defaultPreferences.alertReviewRejected })
  public alertReviewRejected: boolean = defaultPreferences.alertReviewRejected

  @Field({ defaultValue: defaultPreferences.alertNewExternalReview })
  public alertNewExternalReview: boolean = defaultPreferences.alertNewExternalReview

  // Reviewer
  @Field({ defaultValue: defaultPreferences.alertNewArc })
  public alertNewArc: boolean = defaultPreferences.alertNewArc

  @Field({ defaultValue: defaultPreferences.alertNewArcOtherLanguages })
  public alertNewArcOtherLanguages: boolean = defaultPreferences.alertNewArcOtherLanguages

  @Field({ defaultValue: defaultPreferences.alertNewArcDigest })
  public alertNewArcDigest: boolean = defaultPreferences.alertNewArcDigest

  @Field(t => String, { defaultValue: defaultPreferences.newArcDigestFrequency })
  public newArcDigestFrequency: string = defaultPreferences.newArcDigestFrequency

  @Field(t => String, { defaultValue: defaultPreferences.arcDigestBannerDismissedAt })
  public arcDigestBannerDismissedAt: string = defaultPreferences.arcDigestBannerDismissedAt

  @Field({ defaultValue: defaultPreferences.alertReviewDueIn2Days })
  public alertReviewDueIn2Days: boolean = defaultPreferences.alertReviewDueIn2Days

  @Field(t => Int, { defaultValue: defaultPreferences.reviewSitesFlag })
  public reviewSitesFlag: number = defaultPreferences.reviewSitesFlag

  @Field(t => Int, { defaultValue: defaultPreferences.reviewLanguagesFlag })
  public reviewLanguagesFlag: number = defaultPreferences.reviewLanguagesFlag

  @Field({ nullable: true })
  public hasAmazonReviewRestriction?: boolean

  @Field({ defaultValue: defaultPreferences.alertReadyToReview })
  public alertReadyToReview: boolean = defaultPreferences.alertReadyToReview

  @Field({ defaultValue: defaultPreferences.alertFinalFollowup })
  public alertFinalFollowup: boolean = defaultPreferences.alertFinalFollowup

  @Field({ defaultValue: defaultPreferences.alertDelayExpiring })
  public alertDelayExpiring: boolean = defaultPreferences.alertDelayExpiring

  @Field({ defaultValue: defaultPreferences.alertDelayExpired })
  public alertDelayExpired: boolean = defaultPreferences.alertDelayExpired

  @Field({ defaultValue: defaultPreferences.alertBookFileUpdated })
  public alertBookFileUpdated: boolean = defaultPreferences.alertBookFileUpdated

  @Field({ defaultValue: defaultPreferences.emailOnMessage })
  public emailOnMessage: boolean = defaultPreferences.emailOnMessage

  @Field({ defaultValue: defaultPreferences.alertNewTeamApplicant })
  public alertNewTeamApplicant: boolean = defaultPreferences.alertNewTeamApplicant

  @Field({ defaultValue: defaultPreferences.invitedToTeam})
  public invitedToTeam: boolean = defaultPreferences.invitedToTeam

  @Field({ defaultValue: defaultPreferences.freeText })
  public freeText: boolean = defaultPreferences.freeText

  @Field({ defaultValue: defaultPreferences.alertSavedArcEndingOrLowCopies })
  public alertSavedArcEndingOrLowCopies: boolean = defaultPreferences.alertSavedArcEndingOrLowCopies

  @Field({ defaultValue: defaultPreferences.findArcFilters })
  public findArcFilters: string = defaultPreferences.findArcFilters

  @Field(t => String, { defaultValue: defaultPreferences.brevoLists })
  public brevoLists: string = defaultPreferences.brevoLists

  // The language the apps are displayed in. Follows the account rather than the device; the
  // bs-locale cookie is what actually drives rendering, and this is what re-seeds it on a new one.
  @Field(t => String, { defaultValue: defaultPreferences.uiLocale })
  public uiLocale: string = defaultPreferences.uiLocale

  public constructor (partial?: UserPreferencesDto) {
    Object.assign(this, partial)
  }
}
